module.exports = __webpack_public_path__ + "static/img/collins_new_logo.28bf7131.png";